import { useState } from "react";
import { Card, Button, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import GeneralForm from "./forms/general/GeneralForm";
import FechasForm from "./forms/general/FechasForm";
import NotasForm from "./forms/general/NotasForm";
import ClasificacionForm from "./forms/instalacion/ClasificacionForm";
import ValoresForm from "./forms/instalacion/ValoresForm";
import TransformadorForm from "./forms/instalacion/TransformadorForm";
import PVInfoForm from "./forms/razonsocial/PVInfoForm";
import PVDomicilioForm from "./forms/razonsocial/PVDomicilioForm";
import PFInfoForm from "./forms/involucrados/PFInfoForm";
import PAInfoForm from "./forms/involucrados/PAInfoForm";
import PSInfoForm from "./forms/involucrados/PSInfoForm";
import DesarrolloForm from "./forms/visita/DesarrolloForm";
import PruebasForm from "./forms/visita/PruebasForm";
import TestigoForm from "./forms/visita/TestigoForm";

export default function DataGroup(props) {
  const { title, subtitle, formName, mainData, setMainData, verification, icon } = props;
  const [visible, setVisible] = useState(false);

  const commonFormProps = {
    mainData,
    setMainData,
    setVisible,
    visible,
    title: formName,
  };

  const formComponents = {
    "Información general": GeneralForm,
    "Fechas": FechasForm,
    "Notas": NotasForm,
    "Información de la Razón social": PVInfoForm,
    "Domicilio de la Razón social": PVDomicilioForm,
    "Persona que firma el contrato": PFInfoForm,
    "Persona que atiende la visita": PAInfoForm,
    "Persona que solicita la verificación": PSInfoForm,
    "Clasificación de la verificación": ClasificacionForm,
    "Valores de la instalación eléctrica": ValoresForm,
    "Información del Transformador": TransformadorForm,
    "Desarrollo de la visita": DesarrolloForm,
    "Pruebas": PruebasForm,
    "Testigo 1": TestigoForm,
    "Testigo 2": TestigoForm,
  };

  const SelectedForm = formComponents[formName] || null;

  return (
    <>
      <Card
        size="small"
        bordered={false}
        style={{
          height: "100%",
          boxSizing: "border-box",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: subtitle ? "0px" : "8px" }}>
          <Space>
            {icon && <span style={{ fontSize: "16px", color: "#1890ff", display: "flex", alignItems: "center" }}>{icon}</span>}
            <span className="name-preview">{title}</span>
          </Space>
          {formName && (
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="small"
              onClick={() => setVisible(true)}
            />
          )}
        </div>
        {subtitle && (
          <div style={{ marginBottom: "8px" }}>
            <span className="name-preview-subtitle">{subtitle}</span>
          </div>
        )}
        <div className="data-group">{props.children}</div>
      </Card>
      {SelectedForm && <SelectedForm {...commonFormProps} verification={formName === "Pruebas" ? verification : undefined} />}
    </>
  );
}
